module.exports = __webpack_public_path__ + "media/images/common/kuchi_hr-4b391415bb33bb38032c5f45e97bb9ac.gif";